export const ALL_CHECK_OPTION = { id: 0, nome: "Todos", checked: false };
